import {useCallback, useEffect, useState} from 'react'
import {useReducedMotion} from 'framer-motion'

const useVideoControl = (init = false, videoRef) => {
    const shouldReduceMotion = useReducedMotion()
    const [isPlaying, setIsPlaying] = useState(init && !shouldReduceMotion)

    useEffect(() => {
        setIsPlaying(init && !shouldReduceMotion)
    }, [init, shouldReduceMotion])

    const onVideoToggle = useCallback(() => {
        setIsPlaying((prev) => !prev)
    }, [])

    const play = useCallback(
        (muteVideo) => {
            if (videoRef.current) {
                videoRef.current.play(muteVideo)
                setIsPlaying(true)
            }
        },
        [videoRef]
    )

    const pause = useCallback(() => {
        if (videoRef.current) {
            videoRef.current.pause()
            setIsPlaying(false)
        }
    }, [videoRef])

    useEffect(() => {
        if (!videoRef?.current) return
        if (isPlaying) {
            videoRef.current.play()
        } else {
            videoRef.current.pause()
        }
    }, [isPlaying, videoRef])

    return [isPlaying, onVideoToggle, {pause, play}]
}

export default useVideoControl
